import { CHANGE_CALENDAR_ACTIVE_MONTH } from "./actionTypes";

export default (type) => ({
  type: CHANGE_CALENDAR_ACTIVE_MONTH,
  payload: {
    type // previous or next
  },
});